module.exports = __webpack_public_path__ + "img/default_avatar.11282052.jpg";